import { api } from "./client";

export function listDeliverables({ signal } = {}) {
  return api("/api/deliverables", { signal });
}

export function getDeliverable(slug, { signal } = {}) {
  return api(`/api/deliverables/${encodeURIComponent(slug)}`, { signal });
}

export function publishDeliverable(slug, force = false, { signal } = {}) {
  return api(`/api/deliverables/${encodeURIComponent(slug)}/publish`, { method: "POST", signal, json: { force } });
}

export function deleteArticle({ brand, slug }, { signal } = {}) {
  return api("/api/tool/delete-article", {
    method: "POST",
    signal,
    json: { brand: brand || "", slug, confirm: true, silent: true },
  });
}
